import { modalNameEnum } from "@/Pages/Auth/Bestellingen/Live";
import { useSetLiveModal } from "@/shared/atoms/useLiveModal";
import { useSetModal } from "@/shared/atoms/useModal";
import useMapOverviewSettingsMutation from "@/shared/mutations/mapOrders/useMapOverviewSettingsMutation";
import useMapOverviewSettingsQuery from "@/shared/queries/mapOrders/useMapOverviewSettingsQuery";
import { mapZoomLevels, statussen } from "@/shared/utils/constant";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import BooleanWithLabel from "../Boolean/BooleanWithLabel";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import RadioButtonGroup from "../Input/RadioButtonGroup";
import Select from "../Select/Select";

const MapSettingsModal = (props) => {
  const { pathname } = useLocation();
  const setLiveModal = useSetLiveModal();
  const save = useMapOverviewSettingsMutation();
  const { data, refetch } = useMapOverviewSettingsQuery();
  const setModal = useSetModal();
  const { t } = useTranslation();
  const [options, setOptions] = useState(data);
  const isAutoZoomActive = options?.is_auto_zoom_active;
  const onSave = () => {
    save
      .mutateAsync({
        ...options,
        zoom_level: isAutoZoomActive
          ? mapZoomLevels[0].value
          : options?.zoom_level,
      })
      .then(() => {
        refetch();
        props.onExit();
        if (pathname === "/orders/live") {
          setLiveModal(modalNameEnum.ORDER_MAP);
        }
      });
  };

  return (
    <Modal
      width={{ _: "90%", md: "50rem" }}
      onExit={() => setModal("")}
      {...props}
    >
      <div>
        <h2>{t("settings")}</h2>
        <div className="my-[2rem]">
          <Select
            menuPlacement="bottom"
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            menuPortalTarget={document.getElementById("root")}
            getOptionLabel={(option) => `${t(option.translationKey)}`}
            options={[
              statussen[0],
              statussen[1],
              statussen[2],
              statussen[3],
              statussen[6],
              statussen[4],
            ]}
            isMulti={true}
            label={t("status")}
            value={statussen?.filter((s) =>
              options?.selected_order_statuses?.includes(s.value[0])
            )}
            onChange={(value) => {
              setOptions((v) => ({
                ...v,
                selected_order_statuses: value.flatMap((v) => v.value),
              }));
            }}
          />
        </div>

        <div className="my-[2rem]">
          <BooleanWithLabel
            checked={isAutoZoomActive}
            onChange={(e) =>
              setOptions((options) => ({
                ...options,
                is_auto_zoom_active: e.target.checked,
                zoom_level: e.target.checked
                  ? mapZoomLevels[0].value
                  : (options?.zoom_level ?? 11),
              }))
            }
          >
            {t("autoZoom")}
          </BooleanWithLabel>
        </div>

        {!isAutoZoomActive && (
          <div className="my-[2rem]">
            <RadioButtonGroup
              label={t("zoomLevel")}
              value={options?.zoom_level}
              options={mapZoomLevels.map((level) => ({
                value: level.value,
                label: t(level.translationKey),
              }))}
              onChange={(e) =>
                setOptions((v) => ({
                  ...v,
                  zoom_level: Number(e.target.value),
                }))
              }
            />
          </div>
        )}

        <Button isPending={save.isPending} onClick={onSave}>
          {t("save")}
        </Button>
      </div>
    </Modal>
  );
};
export default MapSettingsModal;
